export default "__VITE_ASSET__612dc6ba__"